import { getClips, videoExist } from '~/helpers/house/matterport'

export const useMatterportUrl = (houseDetails?: {
  matterportUrl?: string | null
}) => {
  const modelId = computed(
    () => houseDetails?.matterportUrl?.split('m=')?.[1] || '',
  )

  const { data: houseMatterportVideoUrl } = useAsyncData(
    `houseMatterportVideoUrl-${modelId.value}`,
    async () => {
      if (modelId.value) {
        const houseMatterportVideo = await getClips(modelId.value).then(
          (res) => res?.data?.model?.assets?.clips || [],
        )

        if (houseMatterportVideo?.length) {
          const video = houseMatterportVideo?.find((v) =>
            v.url.includes('0001-480.mp4'),
          )

          if (video) {
            const exist = await videoExist(video.url)

            if (exist) {
              return { videoUrl: video.url || '' }
            }
          }
        }
      }
      return { videoUrl: '' }
    },
    { watch: [modelId] },
  )

  return computed(() => houseMatterportVideoUrl.value?.videoUrl)
}
